import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import gold from "../../../../../assets/icons/asset-icons/gold.svg";
import ps from "../../../../../assets/icons/asset-icons/profitsharing.svg";
import silver from "../../../../../assets/icons/asset-icons/silver.svg";
import Button from "../../../../common/Button/Button";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Pagination from "../../../../common/Pagination/Pagination";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import TransactionTypeBadge from "../TransactionTypeBadge/TransactionTypeBadge";
import styles from "../Transactions.module.scss";
import OrderDetails from "../../../../common/Modals/OrderDetails/OrderDetails";
import { getType } from "../Transactions";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice, toFix } from "../../../../../utils/utils";
import { format } from "date-fns";
import { getTransactionsAction } from "../../../../../features/user/userSlice";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { useDebounce } from "../../../../customHook/useDebeunce";

const OpenedTransactions = ({ status = "OPENED" }) => {
  const dispatch = useDispatch();
  const search = useOutletContext();
  const [show, setShow] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [imageURL, setImageURL] = useState("");
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [orderId, setOrderId] = useState({ orderId: "", transactionId: "" });

  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const [activeSortColumn, setActiveSortColumn] = useState(null);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const debounced = useDebounce(search, 500);

  const fields = [
    { label: "Order ID" },
    { label: "Asset" },
    { label: "Type" },
    { label: "Qty", sort: true },
    { label: "Price", sort: true },
    { label: "Total" },
    { label: "Created From" },
    { label: "Date", sort: true },
    { label: "Status" },
    { label: "Actions" },
  ];

//   const getTransactions = async () => {
//     setLoading(true);
//     try {
//       const params = {
//         page: page,
//         size: pageSize,
//         filterByStatus: status,
//       };
//       if (debounced) {
//         params.searchKeyword = debounced;
//       }
//       if (activeSortColumn === "Qty") {
//         params.sortByQuantity = quantityOrder === true ? "ASC" : "DESC";
//       }
//       if (activeSortColumn === "Date") {
//         params.sortByDate = dateFilter === true ? "ASC" : "DESC";
//       }
//       if (activeSortColumn === "Price") {
//         params.sortByPrice = priceOrder === true ? "ASC" : "DESC";
//       }
// console.log("params",params)
//       const response = await dispatch(getTransactionsAction(params));
//       if (response.status === 200) {
//         setTransactions(response.data.data.data);
//         setTotalPages(response?.data?.data?.totalPages);
//         setImageURL(response.data.data.imageUrl);
//         setTimeout(() => {
//           setLoading(false);
//         }, 1000);
//       }
//     } catch (error) {
//       setLoading(false);
//       console.log("error", error);
//     }
//   };
const getTransactions = async () => {
  setLoading(true);
  try {
    const params = {
      page: page,
      size: pageSize,
      filterByStatus: status,
    };

    if (debounced) {
      params.searchKeyword = debounced;
    }

    // ✅ Multiple sort support
    if (quantityOrder !== null) {
      params.sortByQuantity = quantityOrder ? "ASC" : "DESC";
    }

    if (priceOrder !== null) {
      params.sortByPrice = priceOrder ? "ASC" : "DESC";
    }

    if (dateFilter !== null) {
      params.sortByDate = dateFilter ? "ASC" : "DESC";
    }


    const response = await dispatch(getTransactionsAction(params));

    if (response.status === 200) {
      setTransactions(response.data.data.data);
      setTotalPages(response?.data?.data?.totalPages);
      setImageURL(response.data.data.imageUrl);

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  } catch (error) {
    setLoading(false);
    console.log("error", error);
  }
};
  const openDetailModal = (orderId, transactionId) => {
    setOrderId({ orderId, transactionId });
    setShow(true);
  };

  // const callBackOnClick = (data) => {
  //   setPage(1);
  //   if (data === "Qty") {
  //     setQuantityOrder((prev) => !prev);
  //     setActiveSortColumn("Qty");
  //   }
  //   if (data === "Price") {
  //     setPriceOrder((prev) => !prev);
  //     setActiveSortColumn("Price");
  //   }
  //   if (data === "Date") {
  //     setDateFilter((prev) => !prev);
  //     setActiveSortColumn("Date");
  //   }
  // };

  const callBackOnClick = (data) => {
  setPage(1);

  if (data === "Qty") {
    setQuantityOrder((prev) => !prev);
  }

  if (data === "Price") {
    setPriceOrder((prev) => !prev);
  }

  if (data === "Date") {
    setDateFilter((prev) => !prev);
  }
};

  useEffect(() => {
    getTransactions();
  }, [page, debounced, activeSortColumn, quantityOrder, priceOrder, dateFilter]);

  return (
    <>
      <Table
        noRecordContent={"No records for your search were found."}
        // noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        loading={loading}
        fields={fields}
        className={styles.table}
        onClick={callBackOnClick}
      >
        {transactions?.length > 0 ? (
          transactions?.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <Tooltip
                    icon={<span>{item.order_id.slice(0, 5) + "..." + item.order_id.slice(-5)}</span>}
                    content={
                      <>
                        <CopyBtn text={item.order_id} /> {item.order_id}
                      </>
                    }
                    className={styles.order_id}
                  />
                </td>
                <td className={styles.asset}>
                  <img
                    alt="asset"
                    src={`${imageURL}${item.master_tokens_configuration?.image}`}
                  />
                  {item.master_tokens_configuration?.name}
                </td>
                <td>
                  <TransactionTypeBadge type={getType(item.type)}>
                    {item.type?.toLowerCase()}
                  </TransactionTypeBadge>
                </td>
                <td>
                  {Number(
                    toFix(
                      Number(item?.quantity),
                      decimalLimit[item.master_tokens_configuration?.name]
                    )
                  )}
                </td>
                <td>
                  {item?.type === "REWARD"
                    ? item?.price != null
                      ? `$${formatPrice(Number(item.price))}`
                      : "N/A"
                    : `$${formatPrice(Number(item?.price))}`}
                </td>
                <td>
                  {item?.type === "REWARD"
                    ? item?.price != null && item?.quantity != null
                      ? `$${formatPrice(
                        Number(item.price) * Number(item.quantity)
                      )}`
                      : "N/A"
                    : `$${formatPrice(
                      Number(item?.price) * Number(item?.quantity)
                    )}`}
                </td>
                <td>{item?.order_created_from}</td>
                <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
                <td className="text-capitalize">
                  {item?.status?.toLowerCase()}
                </td>
                <td>
                  <Button
                    variant="text_blue"
                    className={styles.detail_btn}
                    onClick={() => openDetailModal(item?.order_id, item?.id)}
                  >
                    View Details
                  </Button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={fields.length} style={{ textAlign: "center" }}>
              No records found!
            </td>
          </tr>
        )}
      </Table>
      {/* {transactions?.length > 0 && <Pagination pageCount={3} />} */}
      {transactions?.length > 0 && (
        <Commonpagination
          // className={classpagonation}
          currentPage={page}
          totalPages={totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <OrderDetails
        show={show}
        handleClose={() => setShow(false)}
        orderId={orderId}
      />
    </>
  );
};

export default OpenedTransactions;
